/* Lynx buy box, round 2 (5 Oct 2026), delivery timeline updated in round 7b (11 Oct 2026) and round 8 (12 Oct 2026).
   1) Delivery estimate: dates counted from today in Swedish time (Europe/Stockholm via Intl, not the visitor's
      clock zone), skipping weekends and the dates in HOLIDAYS below.
      Modes: normal (business days), long lead (weeks, real dates) and note only (no dates).
      Which mode applies follows real stock: a variant that is available but has inventory 0 or less (continue
      selling) is in data-ids and gets the lead-time mode set in the theme editor, never the 3-5 day timeline.
      Never shown for variants that cannot be bought.
      Timeline (normal): Beställd = today's date, Skickas = first working day from today (today if it is a working
      day) to the next working day, Levereras = 3-5 working days counted from that same first working day.
      The line above the icons can say how many working days that is: [dagar] in the "Text" setting becomes
      "3-5 arbetsdagar" (from the delivery min/max settings), only in normal (in-stock) mode. Round 8 moved this
      wording from a small label under the last icon into that line. No countdown: Olivier decided against a
      cut-off countdown (round 7b).
   2) Sale tag follows the selected variant.
   3) Small quote carousel.
   4) Stock-aware delivery copy (round 8): while the selected variant is out of stock (inventory 0 or less but still
      orderable, or not orderable at all), short texts on the product page that promise "3-5 arbetsdagar" (trust tile,
      accordion, FAQ, final CTA) are trimmed or hidden, so the out-of-stock note is the only delivery information.
      Restored as soon as an in-stock variant is selected; in stock nothing changes. See StockCopy below.
   5) Fixed delivery window (round 10, 12 Oct 2026): the theme editor settings "Fast leveransfönster, från/till"
      (window_from/window_to, YYYY-MM-DD, data-win on the timeline) give an out-of-stock variant a fixed window
      instead of the out-of-stock note: line "Beställ idag så levereras den mellan 10 och 15 november", steps
      Beställd (today) and Levereras (10-15 nov), no Skickas step because there is no real ship date. A start date
      that has passed is moved up to today, so no past date is ever shown. Only while inventory is 0 or less and
      the variant can still be bought; in stock the normal 3-5 arbetsdagar timeline applies. From the day after the
      end date (Europe/Stockholm) the window is gone and the out-of-stock note shows again. While the window is
      on, the buy box note is hidden (data-win-hide, also set by Liquid so it does not flash) and the final CTA
      note shows the window line instead. Sentences elsewhere on the page that name the window ("10-15 november",
      "mellan 10 och 15 november") are removed when the window is off (expired, in stock or sold out).
   Listens to 'lynx:variant-change' from assets/lynx-redesign.js. */
(function () {
  'use strict';
  if (window.__lxbInit) return; window.__lxbInit = true;

  var MONTHS = ['jan', 'feb', 'mars', 'apr', 'maj', 'juni', 'juli', 'aug', 'sep', 'okt', 'nov', 'dec'];
  var MONTHS_LONG = ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'december'];
  /* Days with no shipping or delivery besides Saturdays and Sundays: Swedish public holidays plus the de facto
     non-working eves (julafton, nyårsafton, midsommarafton) that fall on weekdays. Add future years here as
     'YYYY-MM-DD': 1. Empty the object ({}) to count every weekday as a working day. */
  var HOLIDAYS = {
    '2026-01-01': 1, '2026-01-06': 1, '2026-04-03': 1, '2026-04-06': 1, '2026-05-01': 1, '2026-05-14': 1,
    '2026-06-19': 1, '2026-12-24': 1, '2026-12-25': 1, '2026-12-31': 1,
    '2027-01-01': 1, '2027-01-06': 1, '2027-03-26': 1, '2027-03-29': 1, '2027-05-06': 1, '2027-06-25': 1,
    '2027-12-24': 1, '2027-12-31': 1,
    '2028-01-06': 1
  };
  var DAY = 864e5;

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function iso(d) { return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()); }
  function isBiz(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && !HOLIDAYS[iso(d)]; }
  function nextBiz(d) { var x = new Date(d.getTime() + DAY); while (!isBiz(x)) x = new Date(x.getTime() + DAY); return x; }
  function rollBiz(d) { return isBiz(d) ? d : nextBiz(d); }
  function addBiz(d, n) { var x = d; for (var i = 0; i < n; i++) x = nextBiz(x); return x; }
  function same(a, b) { return a.getTime() === b.getTime(); }

  /* Current date and time in Europe/Stockholm, independent of the visitor's own time zone. */
  function nowSthlm() {
    var p = {};
    try {
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Stockholm', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    } catch (e) {
      var n = new Date(); p = { year: n.getFullYear(), month: n.getMonth() + 1, day: n.getDate(), hour: n.getHours(), minute: n.getMinutes() };
    }
    var h = +p.hour; if (h === 24) h = 0;
    return { date: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)), min: h * 60 + (+p.minute) };
  }

  function fmt(d, withYear, long) { return d.getUTCDate() + '\u00a0' + (long ? MONTHS_LONG : MONTHS)[d.getUTCMonth()] + (withYear ? '\u00a0' + d.getUTCFullYear() : ''); }
  /* "mellan 8 och 10 okt", "mellan 30 okt och 3 nov", "8 okt"; long: "mellan 10 och 15 november" */
  function between(a, b, y, long) {
    if (same(a, b)) return fmt(a, a.getUTCFullYear() !== y, long);
    if (a.getUTCMonth() === b.getUTCMonth() && a.getUTCFullYear() === b.getUTCFullYear()) return 'mellan ' + a.getUTCDate() + ' och\u00a0' + fmt(b, b.getUTCFullYear() !== y, long);
    return 'mellan ' + fmt(a, a.getUTCFullYear() !== y && a.getUTCFullYear() !== b.getUTCFullYear(), long) + ' och ' + fmt(b, b.getUTCFullYear() !== y, long);
  }
  /* Fixed delivery window from data-win="YYYY-MM-DD,YYYY-MM-DD" (round 10). null if missing, invalid or reversed. */
  function parseDay(s) {
    var m = /^\s*(\d{4})-(\d{2})-(\d{2})\s*$/.exec(s || ''); if (!m) return null;
    var d = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3]));
    return (d.getUTCMonth() === +m[2] - 1 && d.getUTCDate() === +m[3]) ? d : null;
  }
  function parseWin(s) {
    var p = String(s || '').split(','), a = parseDay(p[0]), b = parseDay(p[1]);
    return (a && b && a.getTime() <= b.getTime()) ? { a: a, b: b } : null;
  }
  /* Open from today until the end of the last day, Swedish time. */
  function winOpen(win) { return !!win && nowSthlm().date.getTime() <= win.b.getTime(); }
  /* Matches the window as it is written in page copy: "10-15 november", "mellan 10 och 15 nov",
     "28 nov-3 dec", "28 november till 3 december". A non-breaking hyphen (U+2011, "10\u201115") also counts. */
  function winRe(win) {
    if (!win) return null;
    var a = win.a, b = win.b, sep = '\\s*(?:-|\\u2011|\\u2013|och|till)\\s*', sp = '[\\s\\u00a0]+';
    function mon(d) { return MONTHS[d.getUTCMonth()].slice(0, 3) + '[a-z\\u00e5\\u00e4\\u00f6]*'; }
    var src = (a.getUTCMonth() === b.getUTCMonth() && a.getUTCFullYear() === b.getUTCFullYear())
      ? a.getUTCDate() + sep + b.getUTCDate() + sp + mon(b)
      : a.getUTCDate() + sp + mon(a) + sep + b.getUTCDate() + sp + mon(b);
    return new RegExp('(^|[^\\d])' + src + '(?![a-z\\u00e5\\u00e4\\u00f6])', 'i');
  }
  /* "14 dec till 28 dec" */
  function fromTo(a, b, y) {
    if (same(a, b)) return fmt(a, a.getUTCFullYear() !== y);
    return fmt(a, a.getUTCFullYear() !== y && a.getUTCFullYear() !== b.getUTCFullYear()) + ' till ' + fmt(b, b.getUTCFullYear() !== y);
  }
  /* compact range for the timeline: "6-7 okt", "30 okt-2 nov", "idag" */
  function short(a, b, today, todayLabel) {
    if (same(a, b)) return same(a, today) ? todayLabel : fmt(a);
    if (a.getUTCMonth() === b.getUTCMonth()) return a.getUTCDate() + '-' + fmt(b);
    return fmt(a) + '-' + fmt(b);
  }
  function nums(s, a, b) { var p = String(s || '').split(','); var x = parseInt(p[0], 10), y = parseInt(p[1], 10); x = isNaN(x) ? a : Math.max(0, x); y = isNaN(y) ? b : Math.max(x, y); return [x, y]; }
  function parseCutoff(s) { var m = /^\s*(\d{1,2})[:.](\d{2})\s*$/.exec(s || ''); if (!m) return null; var h = +m[1], mi = +m[2]; if (h > 23 || mi > 59) return null; return h * 60 + mi; }
  function duration(min) { var h = Math.floor(min / 60), m = min % 60; return (h ? h + ' h ' : '') + m + ' min'; }

  /* Fill a template like "Beställ idag så levereras den inom [dagar], [datum]" safely (text nodes only).
     A token without a value is dropped together with the comma or space that joins it to the rest. */
  function fill(el, tpl, tokens) {
    el.textContent = '';
    var t = String(tpl || '');
    if (tokens.dagar == null) t = t.replace(/\s*(inom\s+)?\[dagar\],?/g, '');
    var parts = t.split(/(\[datum\]|\[tid\]|\[dagar\])/);
    parts.forEach(function (part) {
      if (part === '[datum]' && tokens.datum != null) { var s = document.createElement('strong'); s.textContent = tokens.datum; el.appendChild(s); }
      else if (part === '[tid]' && tokens.tid != null) { var e = document.createElement('em'); e.textContent = tokens.tid; el.appendChild(e); }
      else if (part === '[dagar]' && tokens.dagar != null) { var d = document.createElement('span'); d.style.whiteSpace = 'nowrap'; d.textContent = tokens.dagar; el.appendChild(d); }
      else if (part && part.charAt(0) !== '[') el.appendChild(document.createTextNode(part));
    });
  }

  function Ship(box) {
    this.box = box;
    this.ids = box.getAttribute('data-ids') || ',';
    this.mode = box.getAttribute('data-mode') || 'auto';
    this.back = box.getAttribute('data-backorder') || 'note';
    this.ship = nums(box.getAttribute('data-ship'), 0, 1);
    this.del = nums(box.getAttribute('data-del'), 3, 5);
    this.weeks = nums(box.getAttribute('data-weeks'), 0, 0);
    this.cutoff = parseCutoff(box.getAttribute('data-cutoff'));
    this.line = box.querySelector('[data-lxb-line]');
    this.s1 = box.querySelector('[data-lxb-s1]');
    this.s2 = box.querySelector('[data-lxb-s2]');
    this.s3 = box.querySelector('[data-lxb-s3]');
    this.mid = box.querySelector('[data-lxb-mid]');
    this.todayLabel = box.getAttribute('data-today') || 'idag';
    this.win = parseWin(box.getAttribute('data-win'));
    this.tWin = box.getAttribute('data-t-win') || 'Beställ idag så levereras den [datum]';
    this.variant = { id: box.getAttribute('data-vid'), available: box.getAttribute('data-avail') === '1' };
    this.timer = null;
  }
  Ship.prototype.kind = function () {
    var v = this.variant;
    if (!v || !v.available) return 'none';
    if (this.mode === 'off') return 'none';
    var backorder = this.ids.indexOf(',' + v.id + ',') > -1;
    if (backorder && winOpen(this.win)) return 'window';
    if (this.mode === 'long') return this.weeks[1] > 0 ? 'long' : 'none';
    if (!backorder) return 'normal';
    return (this.back === 'long' && this.weeks[1] > 0) ? 'long' : 'none';
  };
  /* The window still ahead of us: a start date that has passed is moved up to today. */
  Ship.prototype.range = function (today) {
    var a = this.win.a.getTime() < today.getTime() ? today : this.win.a;
    return [a, this.win.b];
  };
  /* Plain-text window line for notes outside the timeline, or null when the window is off. */
  Ship.prototype.winText = function () {
    if (this.kind() !== 'window') return null;
    var today = nowSthlm().date, r = this.range(today);
    return String(this.tWin).replace(/\s*(inom\s+)?\[dagar\],?/g, '').replace(/\[tid\]/g, '')
      .replace('[datum]', between(r[0], r[1], today.getUTCFullYear(), true)).replace(/\s+$/, '');
  };
  Ship.prototype.render = function () {
    var box = this.box, k = this.kind(), self = this;
    if (this.timer) { clearInterval(this.timer); this.timer = null; }
    if (k === 'none') { box.hidden = true; return; }
    var now = nowSthlm(), today = now.date, y = today.getUTCFullYear();
    this.s1.textContent = fmt(today);
    if (k === 'window') {
      var r = this.range(today);
      fill(this.line, this.tWin, { datum: between(r[0], r[1], y, true) });
      this.s3.textContent = short(r[0], r[1], new Date(0), '');  /* always a date, never "idag" */
      if (this.mid) this.mid.hidden = true;
      box.classList.add('is-two');
      box.hidden = false;
      return;
    }
    if (k === 'long') {
      var a = rollBiz(new Date(today.getTime() + this.weeks[0] * 7 * DAY));
      var b = rollBiz(new Date(today.getTime() + this.weeks[1] * 7 * DAY));
      fill(this.line, box.getAttribute('data-t-long'), { datum: fromTo(a, b, y) });
      this.s3.textContent = short(a, b, today, this.todayLabel);
      if (this.mid) this.mid.hidden = true;
      box.classList.add('is-two');
      box.hidden = false;
      return;
    }
    if (this.mid) this.mid.hidden = false;
    box.classList.remove('is-two');
    var beforeCutoff = this.cutoff == null || now.min < this.cutoff;
    var base = (isBiz(today) && beforeCutoff) ? today : nextBiz(today);
    var s1 = addBiz(base, this.ship[0]), s2 = addBiz(base, this.ship[1]);
    var d1 = addBiz(base, this.del[0]), d2 = addBiz(base, this.del[1]);
    var datum = between(d1, d2, y);
    /* round 7b: no countdown text, even if a cut-off time is set in the editor (decided by Olivier) */
    fill(this.line, box.getAttribute('data-t-line'), { datum: datum, dagar: this.del[0] + '-' + this.del[1] + '\u00a0arbetsdagar' });
    this.s2.textContent = short(s1, s2, today, this.todayLabel);
    this.s3.textContent = short(d1, d2, today, this.todayLabel);
    box.hidden = false;
  };

  /* 4) Stock-aware delivery copy. Finds every text node on the product page that mentions "x-y arbetsdagar" or the
     "före klockan 14" shipping promise, outside the timeline and the out-of-stock note. Out of stock:
     - a clause joined by "och" or a comma is cut ("Fri frakt, 3-5 arbetsdagar" -> "Fri frakt",
       "... i Sverige och leveransen tar normalt 3-5 arbetsdagar." -> "... i Sverige."),
     - any other sentence with the promise is dropped, and so is the "före klockan 14" sentence after it,
     - a sentence that says "i lager" is conditional ("när panelen finns i lager ...") and is kept, with the
       sentence that follows it,
     - an element left without text (a trust tile line, a list item) is hidden.
     In stock, every node gets its original text back. */
  var DAYS = /\d+\s*[-\u2013]\s*\d+[\s\u00a0]*arbetsdagar/i;
  var DAYS_CLAUSE = /(\s*,\s*|\s+och\s+)(normalt\s+)?(leverans(en)?\s+)?(inom\s+|tar\s+(normalt\s+)?)?\d+\s*[-\u2013]\s*\d+[\s\u00a0]*arbetsdagar/i;
  var CUTOFF = /klockan\s*14/i;
  var COND = /\bi\s+lager\b/i;
  function trimCopy(text) {
    var parts = text.match(/[^.!?]+[.!?]*\s*/g) || [text];
    var out = [], prevCond = false, prevCut = false;
    parts.forEach(function (p) {
      if (COND.test(p)) { out.push(p); prevCond = true; prevCut = false; return; }
      if (DAYS.test(p)) {
        var c = p.replace(DAYS_CLAUSE, '');
        if (c !== p && /[A-Za-zÅÄÖåäö]/.test(c)) out.push(c);
        prevCond = false; prevCut = true; return;
      }
      if (CUTOFF.test(p) && !prevCond) { prevCut = true; return; }
      out.push(p); prevCond = false; prevCut = false;
    });
    return out.join('');
  }
  /* round 10: drop every sentence that names the fixed delivery window (used when the window is off). */
  function dropWin(text, re) {
    var parts = text.match(/[^.!?]+[.!?]*\s*/g) || [text];
    return parts.filter(function (p) { return !re.test(p); }).join('');
  }
  function StockCopy(win) {
    this.items = [];
    this.win = winRe(win);
    var self = this;
    Array.prototype.forEach.call(document.querySelectorAll('.lynx'), function (scope) {
      if (scope.parentElement && scope.parentElement.closest('.lynx')) return;
      var w = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null), n;
      while ((n = w.nextNode())) {
        var el = n.parentElement;
        if (!el || /^(SCRIPT|STYLE|NOSCRIPT|TEMPLATE)$/.test(el.tagName)) continue;
        if (el.closest('[data-lxb-ship], [data-delivery], .lx-delivery')) continue;
        if (!DAYS.test(n.nodeValue) && !CUTOFF.test(n.nodeValue) && !(self.win && self.win.test(n.nodeValue))) continue;
        self.items.push({ node: n, orig: n.nodeValue, el: el.closest('li, p, span, b, div') || el });
      }
    });
  }
  StockCopy.prototype.apply = function (oos, winOn) {
    var re = this.win;
    this.items.forEach(function (it) {
      var t = oos ? trimCopy(it.orig) : it.orig;
      if (re && !winOn) t = dropWin(t, re);
      it.node.nodeValue = t;
      var empty = oos && !/[A-Za-zÅÄÖåäö0-9]/.test(it.el.textContent);
      if (empty) { it.el.setAttribute('data-lxb-oos-hidden', ''); it.el.style.display = 'none'; }
      else if (it.el.hasAttribute('data-lxb-oos-hidden')) { it.el.removeAttribute('data-lxb-oos-hidden'); it.el.style.display = ''; }
    });
  };
  function isOos(sec, v) {
    if (!v) return false;
    if (!v.available) return true;
    var src = sec.querySelector('[data-lxb-ship], [data-delivery]');
    var ids = (src && src.getAttribute('data-ids')) || ',';
    return ids.indexOf(',' + v.id + ',') > -1;
  }
  function firstVariant(sec) {
    var box = sec.querySelector('[data-lxb-ship]');
    if (box) return { id: box.getAttribute('data-vid'), available: box.getAttribute('data-avail') === '1' };
    var inp = sec.querySelector('[data-lynx-main] input[name="id"]'), btn = sec.querySelector('[data-lynx-main-atc]');
    return inp ? { id: String(inp.value), available: !(btn && btn.disabled) } : null;
  }

  /* round 10: out-of-stock notes while the fixed window is on. The buy box note is hidden (the timeline shows the
     window); a note outside the buy box (final CTA) shows the window line instead of its own text. */
  function WinNotes(sec) {
    var items = this.items = [];
    Array.prototype.forEach.call(sec.querySelectorAll('[data-delivery]'), function (p) { items.push({ el: p }); });
    Array.prototype.forEach.call(document.querySelectorAll('.lx-delivery'), function (p) {
      if (p.hasAttribute('data-delivery') || p.closest('.lx-hero')) return;
      var s = p.querySelector('span');
      if (s) items.push({ el: p, span: s, orig: s.innerHTML });
    });
  }
  WinNotes.prototype.apply = function (text) {
    this.items.forEach(function (it) {
      if (!it.span) { if (text) it.el.setAttribute('data-win-hide', ''); else it.el.removeAttribute('data-win-hide'); }
      else if (text) it.span.textContent = text;
      else it.span.innerHTML = it.orig;
    });
  };

  function initQuotes(root) {
    var q = root.querySelector('[data-lxb-quotes]');
    if (!q || q.__lxb) return; q.__lxb = true;
    var track = q.querySelector('[data-lxb-qtrack]');
    var prev = q.querySelector('[data-lxb-qprev]'), next = q.querySelector('[data-lxb-qnext]');
    if (!track || !prev || !next) return;
    var n = track.children.length;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function cur() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function go(i) { i = (i + n) % n; track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); }
    prev.addEventListener('click', function () { go(cur() - 1); });
    next.addEventListener('click', function () { go(cur() + 1); });
  }

  function init(root) {
    root = root || document;
    Array.prototype.forEach.call(root.querySelectorAll('.lx-hero'), function (sec) {
      if (sec.__lxb) return; sec.__lxb = true;
      var box = sec.querySelector('[data-lxb-ship]');
      var ship = box ? new Ship(box) : null;
      if (ship) ship.render();
      var notes = new WinNotes(sec);
      var wt = ship ? ship.winText() : null;
      notes.apply(wt);
      var copy = window.__lxbCopy || (window.__lxbCopy = new StockCopy(ship ? ship.win : null));
      copy.apply(isOos(sec, firstVariant(sec)), !!wt);
      initQuotes(sec);
      sec.addEventListener('lynx:variant-change', function (e) {
        var v = e.detail && e.detail.variant;
        var sale = sec.querySelector('[data-lxb-sale]');
        if (sale) sale.hidden = !(v && v.compare_at_price && v.compare_at_price > v.price);
        if (ship) { ship.variant = v ? { id: String(v.id), available: !!v.available } : null; ship.render(); }
        var t = ship ? ship.winText() : null;
        notes.apply(t);
        copy.apply(isOos(sec, v ? { id: String(v.id), available: !!v.available } : null), !!t);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
